import type { JailbreakPresetListItem } from '../../services/types';

interface PresetSelectorProps {
  presets: JailbreakPresetListItem[];
  selectedPresetId: string;
  onPresetChange: (presetId: string) => void;
  onLoad: () => void;
  onSaveAs: () => void;
  onManage: () => void;
  isLoading: boolean;
}

export function PresetSelector({
  presets,
  selectedPresetId,
  onPresetChange,
  onLoad,
  onSaveAs,
  onManage,
  isLoading,
}: PresetSelectorProps) {
  return (
    <div className="card p-4">
      <div className="flex flex-wrap items-center gap-3">
        <label className="text-sm font-medium text-neutral-700 dark:text-neutral-300">
          Preset:
        </label>
        <select
          value={selectedPresetId}
          onChange={(e) => onPresetChange(e.target.value)}
          disabled={isLoading}
          className="select flex-1 min-w-[200px]"
        >
          <option value="">-- 選擇 Preset --</option>
          {presets.map((preset) => (
            <option key={preset.id} value={preset.id}>
              {preset.name} {preset.is_default ? '(預設)' : ''}
            </option>
          ))}
        </select>
        <button
          onClick={onLoad}
          disabled={!selectedPresetId}
          className="btn btn-secondary btn-sm"
        >
          載入
        </button>
        <button onClick={onSaveAs} className="btn btn-secondary btn-sm">
          另存為
        </button>
        <button onClick={onManage} className="btn btn-ghost btn-sm">
          管理 Preset
        </button>
      </div>
    </div>
  );
}
